<div class="wrapper">
    <div class="header dave-background-image">
        <h2 mat-dialog-title>Neuen Benutzer anlegen</h2>
    </div>
    <div class="body">
        <div class="content card-wrapper">
            <mat-card class="card">
                <form [formGroup]="UserForm" (ngSubmit)="Submit()">
                    <div class="input">
                        <div class="container">
                            <app-textfield
                                Key="Vorname"
                                [Value]="Firstname"
                                class="full"
                            ></app-textfield>
                            <app-textfield
                                Key="Nachname"
                                [Value]="Lastname"
                                class="full"
                            ></app-textfield>
                            <app-textfield
                                Required
                                Key="E-Mail"
                                [Value]="Email"
                                class="full"
                            ></app-textfield>
                        </div>
                        <div class="buttons">
                            <div class="cancel-button-wrapper">
                                <button
                                    class="button"
                                    app-button
                                    type="button"
                                    Inverted
                                    (click)="Cancel()"
                                >
                                    Abbrechen
                                </button>
                            </div>

                            <button
                                class="button"
                                app-button
                                [Disabled]="UserForm.invalid"
                            >
                            Speichern
                            </button>
                        </div>
                    </div>
                </form>
            </mat-card>
        </div>
    </div>
    <div class="dave-background-image"></div>
</div>
